export default __webpack_public_path__ + "static/media/search_notif.e955b1bf.svg";